import { TariffViewModel } from '@common/model/billing/tariff/view';
import { parse } from 'iso8601-duration';

/**
 * Возвращает количество дней, лет, или месяцев в периоде оплаты тарифа
 * @param tariff
 */
export const getTariffTermCount = (tariff: TariffViewModel): number => {
  if (!tariff.period) {
    return 0;
  }
  return Object.values(parse(tariff.period)).reduce((acc, value) => (Number.isInteger(value) && value > 0 ? value : acc), 0);
};
